import { IAppState } from '../../../AppModulesWrapper';

import { IModulePublishTermsResponse } from '../../types/module';

import { getPublishTerms } from '../../sagas/checkoutInfo/checkService/utils';
import { mapPublishTerms } from '../../thunks/offer/publishOffer/utils';
import { mapPublishTerm } from '../../sagas/checkoutInfo/checkService/utils/mapPublishTerm';
import { selectCurrentBet, selectIsAuctionSelected } from '../auction';
import { selectIsAutoProlongChecked, selectIsInsufficientFunds } from '../checkoutInfo';
import {
  selectActivePackage,
  selectActiveService,
  selectCheckoutDetails,
  selectIsIncreaseToMinimalTopBet,
  selectIsUnavailableImportOfferPromotionForSelfMoneySource,
  selectIsWithoutServices,
  selectPublicationPeriod,
  selectPublicationTokens,
  selectServiceUnavailableReason,
} from '../publishTerms';
import { selectIsSubagentMasterAccountMoneyLimitExceeded, selectRecommendedDepositAmount } from '../balance';
import { selectIsModuleWithPromotion } from './selectIsModuleWithPromotion';
import { selectTermsDurationInDays } from '../termsDurations';
import { selectActivePlacingType } from '../../reducers/v2/paidPublication/selectors';
import { selectMinimalBet } from '../../reducers/v2/promotion/selectors';
import { selectPlacingMoneySource } from '../../reducers/v2/moneySources/selectors';
import { logPublicationTokens } from '../../utils/logPublicationTokens';
import { ILogger } from '@cian/logger';

export const selectModulePublishTermsResponse = (state: IAppState, logger: ILogger): IModulePublishTermsResponse => {
  const { auction, calltracking } = state.servicePickerWidget;

  const service = selectActiveService(state);
  const servicePackage = selectActivePackage(state);
  const publicationPeriod = selectPublicationPeriod(state);
  const isAuctionSelected = selectIsAuctionSelected(state);
  const placingType = selectActivePlacingType(state);
  const isAutoprolongChecked = selectIsAutoProlongChecked(state);
  const moneySource = selectPlacingMoneySource(state);
  const increaseToMinimalTopBet = selectIsIncreaseToMinimalTopBet(state);
  const isWithoutServices = selectIsWithoutServices(state);
  const minimalBet = selectMinimalBet(state);
  const termsDurationInDays = selectTermsDurationInDays(state);
  const checkoutDetails = selectCheckoutDetails(state);
  const isInsufficientFunds = selectIsInsufficientFunds(state);
  const shouldSwitchToSelf = selectIsSubagentMasterAccountMoneyLimitExceeded(state);
  const shouldSwitchToMaster = selectIsUnavailableImportOfferPromotionForSelfMoneySource(state);
  const withPromotion = selectIsModuleWithPromotion(state);
  const unavailableReason = selectServiceUnavailableReason(state);
  const publicationTokens = selectPublicationTokens(state);
  const currentBet = selectCurrentBet(state);
  const recommendedDepositAmount = selectRecommendedDepositAmount(state);

  logPublicationTokens(logger, state, publicationTokens, 'selectModulePublishTermsResponse');

  const terms = getPublishTerms({
    service,
    servicePackage,
    publicationPeriod,
    placingType,
    auction,
    isAuctionSelected,
    calltracking,
    moneySource,
    increaseToMinimalTopBet,
    isWithoutServices,
    minimalBet,
    termsDurationInDays,
    currentBet,
  });
  const { terms: mappedTerms = [] } = mapPublishTerms({ isAutoprolongChecked, terms, publicationTokens }) || {};

  return {
    promotionTerm: withPromotion && service ? mapPublishTerm(service.period) : null,
    needToPay: Boolean(checkoutDetails.length),
    autoprolong: isAutoprolongChecked,
    terms: mappedTerms || [],
    shouldSwitchToMaster,
    shouldSwitchToSelf,
    unavailableReason: isWithoutServices ? null : unavailableReason,
    notEnoughMoney: shouldSwitchToSelf ? false : isInsufficientFunds,
    publicationTokens,
    moneySource,
    recommendedDepositAmount,
  };
};
